import React from 'react';
import BackgroundVideo from './components/backgroundVideo/backgroundVideo';
import Home from './components/home/home';
import classes from './App.module.css';
import Dropbtn from './components/dropbtn/dropbtn';

function App() {
  return (
    <div className={classes.container}>
      <BackgroundVideo />
      <Dropbtn />
      <Home />
    </div>
  );
}

export default App;
